<template>
  <div>
    <div v-if="render">
      <b-row>
        <b-col>
          <b-button variant="success" class="float-right mb-2" v-b-toggle.neuesGeraet><font-awesome-icon icon="plus"/> Neues Gerät</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-collapse id="neuesGeraet" class="mb-4" v-model="visible">
            <b-card>
              <b-row>
                <b-col>
                  <b-button
                    variant="outline-secondary"
                    size="sm"
                    class="float-right"
                    @click="neuesGeraetCancel"
                    v-b-tooltip.hover title="Abbrechen"
                    >X</b-button>

                </b-col>
              </b-row>
              
              <b-form @submit.prevent="adminBenutzerNeuesGeraet">
                <b-form-group id="geraetekennung-group" label="Name" label-for="geraetekennung">
                  <b-form-input
                    id="geraetekennung"
                    v-model="neuesGeraet.geraetekennung"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
                <b-form-group id="sigfoxDeviceId-group" label="SigfoxDevice Id" label-for="sigfoxDeviceId">
                  <b-form-input
                    id="sigfoxDeviceId"
                    v-model="neuesGeraet.sigfoxDeviceId"
                    type="text"
                  ></b-form-input>
                </b-form-group>
                <!-- <b-form-group id="geraetetypId-group" label="Gerätetyp" label-for="geraetetypId">
                  <b-form-select
                    id="geraetetypId"
                    v-model="neuesGeraet.geraetetypId"
                    required
                  >
                    <option v-for="geraetetyp in geraetetypen" :key="geraetetyp.id" :value="geraetetyp.id">{{geraetetyp.titel}}</option>
                  </b-form-select>
                </b-form-group> -->
                <b-button type="submit" variant="success" class="float-right">Hinzufügen</b-button>
                <b-button
                    variant="secondary"
                    class="float-right mr-2"
                    @click="neuesGeraetCancel"
                    >Abbrechen</b-button>
              </b-form>
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>


      <div v-if="benutzerGeraete.length == 0">
        <b-alert variant="danger" show>Keine Geraete gefunden.</b-alert>
      </div>
      <div v-else>
        <b-row class="mb-3">
          <b-col><strong>Id</strong></b-col>
          <b-col><strong>Name</strong></b-col>
          <b-col><strong>DeviceId</strong></b-col>
          <b-col><strong>Typ</strong></b-col>
          <b-col></b-col>
        </b-row>
        <hr>
        <div v-for="geraet in benutzerGeraete" :key="geraet.id" class="mb-3 py-2 border-bottom">
          <BenutzerGeraeteBearbeitenRow :geraet="geraet" :benutzer="benutzer" @updUserToast="emitToast"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BenutzerGeraeteBearbeitenRow from './BenutzerGeraeteBearbeitenRow'

export default {
  name: 'BenutzerGeraeteBearbeiten',
  props: ["benutzer"],
  components: {
    BenutzerGeraeteBearbeitenRow
  },
  computed: {
    ...mapGetters(['alleBenutzer', 'adminStatus', 'geraetetypen'])
  },
  methods: {
    ...mapActions(['adminGetBenuzterGeraete', 'adminBenutzerGeraetAnlegen']),
    adminBenutzerNeuesGeraet () {
      this.adminBenutzerGeraetAnlegen({userId: this.benutzer.id, geraet: this.neuesGeraet}).then(() => {
        const toastData = {
          title: "",
          msg: "Ein neues Gerät wurde hinzugefügt.",
          variant: "success"
        };

        if (this.adminStatus.errMsg) {
          (toastData.title = this.adminStatus.errMsg + "..."),
            (toastData.msg = "Es ist etwas schief gelaufen.");
          toastData.variant = "danger";
        }

        this.$emit("updUserToast", toastData);

        if (!this.adminStatus.errMsg) {
          this.visible = false
          this.neuesGeraet = {
            id: 0,
            geraetekennung: '',
            geraetetypId: 10000001,
            benutzerId: this.benutzer.id,
            sigfoxDeviceId: ''
          }
        }
      });
    },
    neuesGeraetCancel () {
      this.visible = false
      this.neuesGeraet = {
        id: 0,
        geraetekennung: '',
        geraetetypId: 10000001,
        benutzerId: this.benutzer.id,
        sigfoxDeviceId: ''
      }
    },
    emitToast (toastData) {
      this.$emit("updUserToast", toastData)
    },
  },
  data () {
    return {
      render: false,
      benutzerGeraete: [],
      neuesGeraet: {
        id: 0,
        geraetekennung: '',
        geraetetypId: 10000001,
        benutzerId: this.benutzer.id,
        sigfoxDeviceId: ''
      },
      visible: false 
    }
  },
  mounted() {
    this.render = false

    this.adminGetBenuzterGeraete(this.benutzer.id)
      .then(() => {
        let index = this.alleBenutzer.findIndex(b => b.id === this.benutzer.id)
        if (index !== null) {
          this.benutzerGeraete = this.alleBenutzer[index].geraete
          this.render = true
        }
      })
  }

}
</script>

<style>

</style>